import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type CreateWebhookMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateWebhookInput;
}>;

export type CreateWebhookMutationResult = { __typename?: 'Mutation' } & {
  webhookSubscriptionsCreateWebhook?: GraphQLTypes.Maybe<
    { __typename?: 'CreateWebhookPayload' } & Pick<GraphQLTypes.CreateWebhookPayload, 'signToken'> & {
        errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      }
  >;
};

export const CreateWebhookDocument = gql`
  mutation createWebhook($input: CreateWebhookInput!) {
    webhookSubscriptionsCreateWebhook(input: $input) {
      errors {
        message
        path
      }
      signToken
    }
  }
`;
